import React, { useState, useEffect } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import 'rsuite/dist/rsuite.min.css';
import config from "../common/Config";
import AccountService from '../../services/AccountServices';

const MyLadger = () => {

	const accessToken = localStorage.getItem('accessToken');
	const user_id = localStorage.getItem('userId');
	const [dates, setDates] = useState([null, null]);
	const [reportrange, setReportrange] = useState('');

	const [myLadger, setMyLadger] = useState([]);

	const searchFormData = (selectedDates) => {
		let startDate = selectedDates[0] ? format(selectedDates[0], 'MM/dd/yyyy') : '';
		let endDate = selectedDates[1] ? format(selectedDates[1], 'MM/dd/yyyy') : '';
		setReportrange(startDate ? startDate + ' - ' + endDate : '');
		loadMyLadger(startDate, endDate);
	};
    const loadMyLadger = async (startDate, endDate) => {
        try {
            const response = await AccountService.fetchMyLadger(startDate, endDate, accessToken, user_id);
            const ledger = Array.isArray(response?.data?.customer_ledger)
                ? response.data.customer_ledger
                : Array.isArray(response?.data)
                    ? response.data
                    : [];
            setMyLadger(ledger);
        } catch (error) {
            console.log('Failed to load Payment ledger', error);
            setMyLadger([]);
        }
    };

	useEffect(() => {

		if (accessToken === null) {
			window.location.href = `${config.BASE_URL}/login`;
			return;
		}

		loadMyLadger();

	}, []);

	useEffect(() => {
        const table = $('#myLadgerList').DataTable({
			pageLength: 50,
			paging: true,
			lengthMenu: [10, 20, 50],
			searching: true,
			ordering: false,
			info: true,
			responsive: true,
			autoWidth: false,
            destroy: true,
			language: {
				paginate: {
					first: 'First',
					last: 'Last',
					next: 'Next',
					previous: 'Previous',
				},
				search: 'Search:',
			},
			data: myLadger,
			columns: [


				{ data: 'date', className: 'text-start', width: '10%' },
				{ data: 'particulars' },
				{ data: 'customer_name' },
				{ data: 'sales_person_name' },
                {
                    data: null,
                    render: function (data, type, row) {
                        const amountNumber = parseFloat(row?.amount);
                        if (row?.payment_type === 'c' && Number.isFinite(amountNumber)) {
                            return amountNumber.toFixed(2);
                        }
                        return '0.00';
                    }
                },
				{
					data: null,
					render: function (data, type, row) {

                        const amountNumber = parseFloat(row?.amount);
                        if (row?.payment_type === 'd' && Number.isFinite(amountNumber)) {
                            return amountNumber.toFixed(2);
                        }
                        return '0.00';
					}
				},
				{
					data: null,
					render: function (data, type, row) {
                        const balanceNumber = parseFloat(row?.balance);
                        return Number.isFinite(balanceNumber) ? balanceNumber.toFixed(2) : '0.00';
					}
				},


			],
			columnDefs: [

			]
		});




		return () => {
			table.destroy();
		};
	}, [myLadger]);

	return (
		<>
			<Header />
			<div className="breadcrumbs">
				<div className="container-fluid">
					<div className="row">
						<div className="col-12 col-lg-12 col-sm-12">
							<Link to="/Dashboard"><i className="fa fa-home"></i></Link>
							<Link to="/account/my_ledger">Account</Link>
							<Link to="/account/my_ledger">My Ledger</Link>
						</div>
					</div>
				</div>
			</div>
			<div className="main-container position-relative">
				<div className="container-fluid">
					<div className="dashboard" style={{ position: 'relative' }} >
						{/* <p><b>My Ledger </b></p> */}

						<div className="row my-ledger-filter" >
							<div className="col-md-12 col-lg-12 col-sm-12 ">
								<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
									<CommonDatePicker
										value={dates}
										// onChange={setDates}
										onChange={(value) => {
											setDates(value);
											if (value && value[0] && value[1]) {
												searchFormData(value);
											}
										}}
									/>
									{/* <button type="button" className="multisubmit" onClick={searchFormData}>Submit</button> */}
								</div>
							</div>
						</div>


						<div className="verical-scrl-wrapper common-table autoheight-table my-ledger-area" id="style-3">
							<table className="table table-bordered dataTable resizable" id="myLadgerList">
								<thead>
									<tr>
										<th>Date</th>
										<th>Particulars</th>
										<th>Customer Name</th>
										<th>Collected By</th>
										<th>Credit</th>
										<th>Debit</th>
										<th>Balance</th>
									</tr>
								</thead>
								<tbody>

								</tbody>
							</table>
						</div>

					</div>
				</div>
			</div>
			<Footer />
		</>
	);

}
export default MyLadger;